(() => {
  const mounted=new WeakSet(),mobileFront=matchMedia('(max-width:767px), (hover:none), (pointer:coarse)');
  function setup(){
    document.querySelectorAll('[data-catalog-item]').forEach(item=>{
      if(mounted.has(item))return;mounted.add(item);
      const front=item.querySelector('[data-photo="front"]'),back=item.querySelector('[data-photo="back"]');
      const detail=item.hasAttribute('data-piece-page'),link=item.querySelector('[data-product-link]');
      const view=value=>{item.dataset.view=value;front?.setAttribute('aria-hidden',String(value!=='front'));back?.setAttribute('aria-hidden',String(value==='front'));item.querySelectorAll('[data-piece-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pieceView===value)));};
      if(front&&!detail){
        const target=item.querySelector('.catalog-link');
        const restingView=()=>view(mobileFront.matches?'front':'back');
        restingView();
        mobileFront.addEventListener('change',()=>{if(item.isConnected)restingView();});
        target.addEventListener('pointerenter',e=>{if(!mobileFront.matches&&e.pointerType!=='touch')view('front');});
        target.addEventListener('pointerleave',restingView);
        target.addEventListener('focus',()=>view('front'));
        target.addEventListener('blur',restingView);
      }
      item.querySelectorAll('[data-piece-view]').forEach(b=>b.addEventListener('click',()=>view(b.dataset.pieceView)));
      const buttons=[...item.querySelectorAll('[data-catalog-color]')];
      const images=window.superGarmentImages;
      let revision=0,committed=buttons.find(b=>b.getAttribute('aria-pressed')==='true');
      const labels=item.closest('[data-departments]')?.dataset||{};
      const status=document.createElement('p');status.className='catalog-load-status';status.setAttribute('role','status');status.hidden=true;item.append(status);
      const choose=async button=>{
        const request=++revision;status.hidden=true;
        buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        item.setAttribute('aria-busy','true');
        try {
          if(images)await Promise.all([images.load(button.dataset.front),images.load(button.dataset.back)]);
          if(request!==revision||!item.isConnected)return;
          if(front){front.loading='eager';front.src=button.dataset.front;}
          if(back){back.loading='eager';back.src=button.dataset.back;}
          if(link){const url=new URL(link.href,location.href);url.searchParams.set('color',button.dataset.catalogColor);link.href=url.href;}
          const colorLabel=button.getAttribute('aria-label');const label=item.querySelector('[data-selected-color]');if(label)label.textContent=colorLabel;committed=button;
          if(front)front.alt=`${item.dataset.title} — ${colorLabel} · ${labels.frontLabel||'Front'}`;if(back)back.alt=`${item.dataset.title} — ${colorLabel} · ${labels.backLabel||'Back'}`;
        } catch {
          if(request===revision){buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===committed)));status.textContent=labels.colorError||'Unable to load this color. Tap the swatch to retry.';status.hidden=false;}
        } finally {if(request===revision)item.removeAttribute('aria-busy');}
      };
      buttons.forEach(b=>{
        b.addEventListener('click',()=>choose(b));
        const anticipate=()=>{images?.load(b.dataset.front).catch(()=>{});images?.load(b.dataset.back).catch(()=>{});};
        b.addEventListener('pointerenter',anticipate);b.addEventListener('focus',anticipate);b.addEventListener('touchstart',anticipate,{passive:true});
      });
      images?.near(item,buttons.flatMap(b=>[b.dataset.front,b.dataset.back]));
      if(detail){const color=new URLSearchParams(location.search).get('color');const selected=buttons.find(b=>b.dataset.catalogColor===color);if(selected)choose(selected);}
    });
  }
  setup();document.addEventListener('shopify:section:load',setup);
})();
